import { Scene } from "../../tools/Scene";
import { LocalizationManager } from "../../managers/LocalizationManager";
import { PreloaderUIScene } from "./PreloaderUIScene";


export class PreloaderBGUIScene extends Scene{

    bg:Phaser.GameObjects.Image|null = null;
    container:Phaser.GameObjects.Sprite|null = null;
    progressContainer:Phaser.GameObjects.Sprite|null = null;
    loadingText:Phaser.GameObjects.Text|null = null;
    blackbar:Phaser.GameObjects.Graphics|null = null;
    progress:Phaser.GameObjects.Graphics|null = null;
    progressBarPosition:Phaser.Math.Vector2|null = null;
    progressBarWidth:number|null = null;
    progressBarHeight:number|null = null;
    progressBarValue:number|null = null;
    tapAnywhereText:Phaser.GameObjects.Text|null = null;
    group:Phaser.GameObjects.Group|null = null;

    preloaderScene:PreloaderUIScene|null = null;

    constructor(sceneConfig, scene){

        super(sceneConfig);
        this.preloaderScene = scene;
    }

    prescaleCreate()
    {

    }

    preload()
    {
        let position;

        this.group = this.add.group({});

        //Window
        position = this.scaleManager.getRelativePosition(.5,.5);
        this.bg = this.add.image(position.x,position.y,'lan_gen_bg');
        // this.bg.visible = false;
        this.container = this.add.sprite(position.x,position.y-12,'gfx_loading');
        this.progressContainer = this.add.sprite(position.x,position.y+60,'gfx_loading_bar_con');
        this.loadingText = this.add.text(position.x-390,position.y+40,LocalizationManager.getText('LOADING'),LocalizationManager.getStyle('LOADING'));

        this.group.add(this.bg);
        this.group.add(this.container);
        this.group.add(this.loadingText);


        //Progress Bar
        this.progressBarWidth = 360;
        this.progressBarHeight = 30;

        let blackbar = this.add.graphics({});
        blackbar.fillStyle(0x000000, 1);
        blackbar.fillRect(position.x, position.y,  this.progressBarWidth, this.progressBarHeight);
        this.blackbar = blackbar;
        this.group.add(this.blackbar);

        let progress = this.add.graphics({});
        this.progress = progress;
        this.progressBarPosition = new Phaser.Math.Vector2(position.x,position.y);
        this.group.add(this.progress);

        // this.load.on('progress', this.moveProgressBar,this);
        this.load.on('complete', this.onProgressBarComplete,this);

        this.reorient(this.scaleManager.isOrientationLandscape());
        this.scaleManager.rescale();

        //Add Scene event bindings
        this.events.on('resize',this.onSceneResize,this);
    }

    update()
    {
        this.moveProgressBar();
    }

    reorient(landscape:boolean){
        let position;
        if(landscape){
            position = this.scaleManager.getRelativePosition(.5,.5);

            this.bg!.setPosition(position.x,position.y);
            this.bg!.setTexture('lan_gen_bg');

            this.container!.setPosition(position.x,position.y-12);
            this.progressContainer!.setPosition(position.x,position.y+70);
            this.loadingText!.setPosition(position.x-195,position.y+40);

            //Progress Bar
            this.progressBarPosition = new Phaser.Math.Vector2(position.x-180,position.y+60);
            this.progressBarWidth = 360;
            this.progressBarHeight = 30;

            this.blackbar!.clear();
            this.blackbar!.fillStyle(0x000000, 1);
            this.blackbar!.fillRect(this.progressBarPosition.x, this.progressBarPosition.y , this.progressBarWidth!, this.progressBarHeight!);
            
            if(this.tapAnywhereText){
                position = this.scaleManager.getRelativePosition(.5,.5);
                this.tapAnywhereText.setPosition(position.x,this.progressBarPosition.y + (this.progressBarHeight/2));
            }
            
        }else{
            position = this.scaleManager.getRelativePosition(.5,.5);

            this.bg!.setPosition(position.x,position.y);
            this.bg!.setTexture('por_gen_bg');

            this.container!.setPosition(position.x,position.y-12);
            this.progressContainer!.setPosition(position.x,position.y+70);
            this.loadingText!.setPosition(position.x-195,position.y+40);

            //Progress Bar
            this.progressBarPosition = new Phaser.Math.Vector2(position.x-180,position.y+60);
            this.progressBarWidth = 360;
            this.progressBarHeight = 30;

            this.blackbar!.clear();
            this.blackbar!.fillStyle(0x000000, 1);
            this.blackbar!.fillRect(this.progressBarPosition.x, this.progressBarPosition.y , this.progressBarWidth!, this.progressBarHeight!);
           
            if(this.tapAnywhereText){
                position = this.scaleManager.getRelativePosition(.5,.5);
                this.tapAnywhereText.setPosition(position.x,this.progressBarPosition.y + (this.progressBarHeight/2));
            }
        }
        this.moveProgressBar();
        this.rescaleBackground();
    }

    rescaleBackground():void {
        //rescale background
        let ratio = this.scaleManager.getRatio();

        if(this.bg!.width * this.bg!.scaleX != window.innerWidth || this.bg!.height * this.bg!.scaleY != window.innerHeight)
        {
            this.bg!.setScale(this.sys.canvas.width/this.bg!.width / ratio! , this.sys.canvas.height/this.bg!.height / ratio!);
        }
    }

    moveProgressBar () {
        this.progress!.clear();
        this.progress!.fillStyle(0x1999f1, 1);
        this.progress!.fillRect(this.progressBarPosition!.x, this.progressBarPosition!.y, this.progressBarWidth! * this.preloaderScene!.progressBarNum!, this.progressBarHeight!);
        this.progressBarValue = this.preloaderScene!.progressBarNum!;
    }

    onSceneResize()
    {
        this.rescaleBackground();
    }


    onProgressBarComplete () {
        this.blackbar!.destroy();
        this.progress!.destroy();
        this.loadingText!.setVisible(false);

        //console.log('IOS:'+this.gameManager!.game!.device.os.iOS +   " iPhone:"+this.gameManager!.game!.device.os.iPhone + " iPAD:"+this.gameManager!.game!.device.os.iPad);
        if(this.gameManager!.game!.device.os.iOS || this.gameManager!.game!.device.os.iPhone || this.gameManager!.game!.device.os.iPad){
            
            let position = this.scaleManager.getRelativePosition(.5,.5);
            let text = this.add.text(position.x,this.progressBarPosition!.y + ((this.progressBarHeight!)/2),LocalizationManager.getText('TAP_ANYWHERE'),LocalizationManager.getStyle('TAP_ANYWHERE'));
            text.setOrigin(0.5);
            this.tapAnywhereText = text;
        }
    }
}

